// ============================================================================
// OBT F3 — Hata normalizasyonu (paket-yerel ince katman)
// ============================================================================
// Ortak `normalizeObtError` READ-ONLY kullanılır. F3'e özel akış mesajları
// (revizyon/karar/finalize) burada eklenir. Ham traceback, storage path, UUID
// veya kontrolsüz backend gövdesi ASLA gösterilmez.
//
// F3 mutasyonlarında (inceleme/karar) backend OPTİMİSTİK version KULLANMAZ;
// 409 durum-önkoşulu ihlalinden gelir (ObtInvalidStateError). Bu yüzden 409'da
// mesaj "kayıt bu sırada değişti, güncel veriyi yükleyin" biçimindedir.
// ============================================================================

import { normalizeObtError, OBT_ERROR_KIND } from '../obtErrors';

const F3_MESSAGES = Object.freeze({
  413: 'Dosya boyutu sınırı aşıldı.',
  415: 'Desteklenmeyen dosya türü.',
});

/**
 * Axios hatasını F3 arayüzünün güvenle gösterebileceği şekle indirger.
 * @returns {{status: number|null, kind: string, message: string}}
 */
export function normalizeReviewError(error) {
  const status = error?.response?.status ?? null;
  if (status === 413 || status === 415) {
    return { status, kind: 'media', message: F3_MESSAGES[status] };
  }
  return normalizeObtError(error);
}

export function isConflict(normalized) {
  return normalized?.kind === OBT_ERROR_KIND.CONFLICT || normalized?.status === 409;
}
export function isForbidden(normalized) {
  return normalized?.kind === OBT_ERROR_KIND.FORBIDDEN || normalized?.status === 403;
}
export function isNotFound(normalized) {
  return normalized?.kind === OBT_ERROR_KIND.NOT_FOUND || normalized?.status === 404;
}
export function isUnprocessable(normalized) {
  return normalized?.status === 422;
}

export { OBT_ERROR_KIND };
